import styled from "styled-components/macro";
// import DeerholdLogo from "../../../public/assets/images/deerwalkLogo.png";
import {
  primary_brand,
  tertiary_brand,
} from "../../assets/StyledComponent/Variables.Style";

export const Header = styled.header`
  width: 90vw;
  height: 10vh;
  padding-top: 10px;
  @media (min-width: 750px) {
    width: auto;
    height: 20vh;
  }
  // position: absolute;
  // top: 5%;
`;

export const TextColor = styled.span`
  font-size: 0.8125rem;
  color: red;
  padding-left: 5px;
  text-transform: capitalize;
`;
export const Container = styled.div`
  width: 100%;
  // position: relative;
  // justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  // background-color: ${tertiary_brand};
  background: #e5e5e5;
`;

export const OverallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 90%;
  width: 100%;
  margin: 0 auto;
  gap: 5%;

  /* padding-bottom: 20px; */
  padding-top: 35px;

  @media (min-width: 750px) {
    min-width: 35%;
    max-width: 0%;
    margin: 0;
    gap: 0%;
    min-height: 70%;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  background: #fafcfe;
  width: 100%;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.04);
  /* flex-direction: column; */
  /* justify-content: sp; */
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 43px;
  margin-bottom: 19px;
`;

export const InputWrapper = styled.div`
  width: 95%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 5px;

  @media (min-width: 750px) {
    width: 71%;
  }
`;

export const LogoForgotPWImage = styled.img`
  src: url(${(props) => props.src});
  width: 25rem;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  // display: inline-block;
  // object-fit: contain;
`;

export const LogoImage = styled.img`
  src: url(${(props) => props.src});

  // display: inline-block;
  // object-fit: contain;

  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  // display: inline-block;
  object-fit: contain;

  @media (min-width: 750px) {
    width: 33.75rem;
    /* object-fit: none; */
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  width: 100%;
  height: 100%;
  align-items: center;

  @media (min-width: 750px) {
    width: 100%;
    height: 100%;
    padding-bottom: 10px;
  }
`;

export const WrapperImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: ${primary_brand};
`;

export const Image = styled.img`
  width: 100%;
  background-image: url(${(props) => props.src});
  /* background-color: ${primary_brand}; */
  opacity: 0.4;
  background-position: left top;
  height: 100%;
  display: inline-block;
  object-fit: cover;
`;

export const InputHeader = styled.h1`
  color: #4492cf;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  padding-top: 15px;

  @media (min-width: 750px) {
    padding-top: 30px;
  }
`;

export const InputText = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #4a4a68;
  padding: 0;
`;

// export const InputDiv = styled.div`
//   display: flex;
//   flex-direction: column;
// `;
// export const ButtonDiv = styled.div`
//   display: flex;
//   align-self: end;
//   margin-top: 5px;
// `;

// export const Input = styled.input`
//   padding: 20px;
//   border: 0.8px solid #e8e8e8;
//   box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.01);
//   border-radius: 10px;
//   font-weight: 500;
// `;

// export const Label = styled.label`
//   font-style: normal;
//   font-weight: 500;
//   font-size: 1rem;
//   line-height: 21px;
//   color: #4a4a68;
//   padding-bottom: 0.3125rem;
// `;
// export const LoginBtn = styled.button`
//   padding: 0.9375rem 0.625rem;
//   background: #e6662c;
//   border-radius: 5px;
//   border: none;
//   color: white;
//   font-weight: 500;
//   font-size: 1rem;
//   :hover {
//     cursor: pointer;
//   }
// `;
// export const TextColor = styled.span`
//   font-size: 0.8125rem;
//   color: red;
//   padding-left: 5px;
//   text-transform: capitalize;
// `;
